<template>
  <div
    class="pastvodWrap"
    :class="{ pipMod: broadcastVodInfo.pipMode }"
    :style="{
      width: broadcastVodInfo.pipMode
        ? window.pastVodPip.pipWidth + 'px'
        : '100%',
      height: broadcastVodInfo.pipMode
        ? window.pastVodPip.pipHeight + 'px'
        : '100%'
    }"
  >
    <!-- <Bar :val="title" :exit="true"/> -->
    <LivePlay
      :vodInfo="vodInfo"
      :broadcastVodInfo="broadcastVodInfo"
      :pipMode="broadcastVodInfo.pipMode"
      :ProductService="ProductService"
      @prdtListFlag="prdtListFlag"
      @prdtQnaFlag="prdtQnaFlag"
      v-if="Object.keys(vodInfo).length > 0"
      :showPrdtModal="showPrdtModal"
      @closeModal="closeModal"
    />

    <PrdtListModal
      :showPrdtModal="showPrdtModal"
      :ProductService="ProductService"
      :exit="true"
      :productList="productList"
      :type="'live'"
      :bcScheduleSysId="broadcastVodInfo.bcScheduleSysId"
      :brdCSysId="broadcastVodInfo.bcSysId"
      @closeModal="closeModal"
    />
    <PrdtQnaModal
      v-if="showQnaModal"
      :showQnaModal="showQnaModal"
      :ProductService="ProductService"
      :exit="true"
      :productList="productList"
      @closeModal="closeModal"
    />

    <div
      class="backPannel"
      :class="{ on: showPrdtModal }"
      @click="closeModal(false)"
    ></div>
  </div>
</template>

<script>
import { getBroadCastVodPlay } from '@/api'
import { AppBridge } from '@/assets/js/common.js'
import LivePlay from '@/components/liveInfo/LivePlay'
import PrdtListModal from '@/components/liveInfo/PastVodPrdtList'
import PrdtQnaModal from '@/components/liveInfo/PastVodPrdtQna'
import productService from '@/service/productService'

export default {
  metaInfo: {
    title: '방송보기'
  },
  name: 'LivePlayer',
  components: {
    LivePlay,
    PrdtListModal,
    PrdtQnaModal
  },
  props: ['broadcastVodInfo'],
  data() {
    return {
      title: '라이브방송',
      vodInfo: {},
      productList: {},
      playInfo: [],
      showPrdtModal: false,
      showQnaModal: false,
      window: window,
      viewCnt: 0,
      ProductService: new productService()
    }
  },

  async mounted() {
    await this.getVodInfo()
  },

  methods: {
    async getVodInfo() {
      let vodInfo = {
        broadcastSysId: null,
        broadcastScheduleSysId: null,
        vodPlaying: false,
        pipMode: false,
        top: 0,
        right: 0
      }
      try {
        let res = await getBroadCastVodPlay(
          sessionStorage.getItem('accessToken'),
          this.broadcastVodInfo.bcSysId,
          this.broadcastVodInfo.bcScheduleSysId
        )
        if (res.data.jsonData.resultCode === '0001') {
          if (
            (!res.data.jsonData.broadcastMedias &&
              res.data.jsonData.broadcastType === 1) ||
            (!res.data.jsonData.liveUrl &&
              res.data.jsonData.broadcastType === 0)
          ) {
            alert('방송 영상 정보가 없습니다.')

            setTimeout(() => {
              window.pastVod(vodInfo)
              AppBridge.send('VodPipExit', { value: 'close' }, true)
            }, 800)
            return
          }
          this.vodInfo = res.data.jsonData
          if (!this.vodInfo.broadcastPrdts) {
            this.vodInfo.broadcastPrdts = []
          }
          this.productList = this.vodInfo.broadcastPrdts
          this.playInfo = this.vodInfo.broadcastMedias
          console.log(res)

          // 번역
          const reqObjInfo = {
            unique: 'broadcastSysId',
            property: ['briefComment', 'title'],
            data: this.vodInfo
          }
          await window.TranslateService.trans(reqObjInfo, this.vodInfo)

          // 번역
          const reqObj = {
            unique: 'broadcastProductSysId',
            property: ['name'],
            data: this.vodInfo.broadcastPrdts
          }
          await window.TranslateService.trans(reqObj, this.productList)
          // 번역

          // 번역
        } else {
          alert('방송 정보가 없습니다.')

          setTimeout(() => {
            window.pastVod(vodInfo)
            AppBridge.send('VodPipExit', { value: 'close' }, true)
          }, 800)
        }
      } catch (err) {
        console.error('방송화면조회 에러', err)
      }
    },
    back() {
      this.$router.push('/demo')
    },
    prdtListFlag() {
      this.showPrdtModal = true
    },
    prdtQnaFlag() {
      this.showQnaModal = true
    },
    closeModal(data) {
      this.showPrdtModal = data
      this.showQnaModal = data
    }
  },
  beforeDestroy() {
    window.closePip()
  },
  watch: {
    broadcastVodInfo: {
      async handler(od, nd) {
        if (od.bcSysId !== nd.bcSysId) {
          let _this = this
          setTimeout(async function () {
            await _this.getVodInfo()
          }, 300)
        }
      }
    }
  }
}
</script>

<style>
.pastvodWrap {
  position: fixed;
  z-index: 10000;
  overflow: hidden;
  width: 100.1%;
  height: 100.1%;
  transition: width 0.3s ease-in-out, height 0.3s ease-in-out;
}
.pastvodWrap.magnet {
  transition: all 0.4s ease-in-out;
}

.pastvodWrap.pipMod {
  border-radius: 5px;
}
.pastvodWrap .pVodTop,
.pastvodWrap .brandImg,
.pastvodWrap .pVodSoundDiv,
.pastvodWrap .pVodClose,
.pastvodWrap .pVodProduct,
.pastvodWrap .fp-ui,
.pastvodWrap .pVodAsk,
.pastvodWrap .pVodIconShow,
.pastvodWrap.pipMod .pVodWrap.modal,
.pastvodWrap .muteBtn,
.pastvodWrap .chatBox,
.pastvodWrap .toolBox {
  opacity: 1;
  transition: all 0.3s ease-in-out;
}
.pastvodWrap .pVodWrap.live .pVodInner .is-muted + .muteBtn,
.pastvodWrap .pVodWrap.live .chatHistory,
.pastvodWrap .pVodWrap.live .hiddenBtn,
.pastvodWrap .pVodWrap.live .hiddenBtn + form {
  opacity: 1;
  transition: all 1s ease-in;
}
.pastvodWrap.pipMod .pVodTop,
.pastvodWrap.pipMod .brandImg,
.pastvodWrap.pipMod .pVodSoundDiv,
.pastvodWrap.pipMod .pVodClose,
.pastvodWrap.pipMod .pVodProduct,
.pastvodWrap.pipMod .fp-ui,
.pastvodWrap.pipMod .pVodIconShow,
.pastvodWrap.pipMod .pVodAsk,
.pastvodWrap.pipMod .chatBox,
.pastvodWrap.pipMod .toolBox {
  opacity: 0;
  transform: scale(0.01, 0.01);
}
.pastvodWrap.pipMod .pVodWrap.live .pVodInner .is-muted + .muteBtn,
.pastvodWrap.pipMod .pVodWrap.live .chatHistory,
.pastvodWrap.pipMod .pVodWrap.live .hiddenBtn,
.pastvodWrap.pipMod .pVodWrap.live .hiddenBtn + form {
  position: absolute;
  transition: all 0.2s ease-in-out;
  opacity: 0;
}
.pastvodWrap.pipMod .pVodWrap.modal {
  overflow: hidden;
  height: 0;
  opacity: 1;
}

.livePlayer + .pVodWrap.modal {
  transform: translateY(100%);
}
.livePlayer + .pVodWrap.modal.open {
  transform: translateY(0);
}

/* .pastvodWrap.pipMod .pVodWrap.live .pVodInner .is-muted + .muteBtn,
.pastvodWrap.pipMod .pVodWrap.live .chatHistory,
.pastvodWrap.pipMod .pVodWrap.live .hiddenBtn,
.pastvodWrap.pipMod .pVodWrap.live .hiddenBtn + form {
  display:none;
} */
</style>